import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { useShowLoadingMessage } from "../hooks/useShowLoadingMessage";
import { useWebsiteKeywordsPage2Context } from "../WebsiteKeywordsPage2Context";

import { NotificationBannerWrapper } from "./NotificationBannerStyledComponents";
import { NotificationBannerForNewPages } from "app/pages/website-analysis/traffic-sources/search/common/NotificationBannerForNewPages";

export const NotificationBanner = () => {
    const { dataTimeout, isLoading } = useWebsiteKeywordsPage2Context();
    const { showLoadingMessage } = useShowLoadingMessage(isLoading);
    return (
        <>
            {dataTimeout ? (
                <NotificationBannerWrapper>
                    <Flex
                        justifyContent="flex-start"
                        alignItems="center"
                        padding="16px"
                        border={`1px solid ${colorsPalettes.red[300]}`}
                        background={colorsPalettes.red[100]}
                        borderRadius="4px"
                        margin="0"
                    >
                        <SWReactIcons
                            size="sm"
                            iconName={"warning"}
                            iconColor={colorsPalettes.red[400]}
                        />
                        <Text
                            fontVariant="body2"
                            color={colorsPalettes.red[500]}
                            margin="0 0 0 8px"
                        >
                            {translate("websiteKeywords.loading.data.banner.error")}
                        </Text>
                    </Flex>
                </NotificationBannerWrapper>
            ) : null}

            {showLoadingMessage ? (
                <NotificationBannerWrapper>
                    <NotificationBannerForNewPages
                        subTitleTxt={translate("websiteKeywords.loading.data.banner.subtitle")}
                        titleTxt={translate("websiteKeywords.loading.data.banner.title")}
                        iconName="time-cycle"
                        pageName={"KEYWORD_ANALYSIS_PAGE_NAME"}
                    />
                </NotificationBannerWrapper>
            ) : null}
        </>
    );
};
